import styled from 'styled-components';

export const StatusContainer = styled.span`
	display: flex;
	align-items: center;
	gap: 5px;
`;

export const StatusDot = styled.span<{ color?: string }>`
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background: ${({ color }) => color};
	margin-right: 8px;
`;
